(function () {
  'use strict';

  var TIER_COL_IDS  = ['mt-col-0', 'mt-col-1', 'mt-col-2'];
  var TIERS         = [3, 5, 10];

  var lastQty       = -1;
  var IS_B2B = window.location.pathname.indexOf('b2b') !== -1;

  // ── Badge aus Shadow DOM lesen ─────────────────────────────
  function getQty() {
    var host = document.querySelector('mw-pdp-offer');
    if (!host || !host.shadowRoot) return 0;
    var badge = host.shadowRoot.querySelector('.HeaderContent-Flexy--badge');
    if (!badge) return 0;
    var v = parseInt(badge.textContent.trim(), 10);
    return isNaN(v) ? 0 : v;
  }

  // ── 1. Scroll wenn auf Tier-Karte geklickt ────────────────
  function initTierScroll() {
    TIER_COL_IDS.forEach(function(id) {
      var col = document.getElementById(id);
      if (!col) return;
      col.addEventListener('click', function() {
        var bundle = document.querySelector('mw-pdp-offer');
        if (!bundle) return;
        var rect = bundle.getBoundingClientRect();
        var scrollTop = window.pageYOffset + rect.top - 200;
        window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        setTimeout(function() {
          bundle.style.transition = 'box-shadow 0.3s ease';
          bundle.style.boxShadow = '0 0 0 3px #A8E63D';
          setTimeout(function() {
            bundle.style.boxShadow = 'none';
          }, 1500);
        }, 600);
      });
    });
  }

  // ── 2. Tier-Karte highlighten ──────────────────────────────
  function updateTierHighlight(qty) {
  var active = -1;
  TIERS.forEach(function(t, i) {
    if (qty >= t) active = i;
  });

  TIER_COL_IDS.forEach(function(id, i) {
    var col = document.getElementById(id);
    if (!col) return;
    if (i === active) {
      col.classList.add('mt-col--reached');
    } else {
      col.classList.remove('mt-col--reached');
    }
    col.style.background = '';
  });
  updateProgressBar(qty);
}

  // ── Haupt-Update ──────────────────────────────────────────
  function update() {
    var qty = getQty();
    if (qty === lastQty) return;

    updateTierHighlight(qty);

    var host = document.querySelector('mw-pdp-offer');
    if (host && host.shadowRoot) {

      // Strikethrough & Sparen stylen
      host.shadowRoot.querySelectorAll('.PdpFooterContent-Price__PriceAmountStrikethrough, .PdpFooterContent-Price__PriceSave').forEach(function(el) {
        el.style.fontSize = '13px';
        el.style.fontWeight = '600';
      });

      host.shadowRoot.querySelectorAll('.PdpFooterContent-Price__PriceText').forEach(function(el) {
  el.childNodes.forEach(function(node) {
    if (node.nodeType === 3) node.textContent = '';
  });
});

      // Unit Tag
      var priceContainer = host.shadowRoot.querySelector('.PdpFooterContent-Price__PriceContainer');
      if (priceContainer) {
        priceContainer.style.display = 'flex';
        priceContainer.style.flexDirection = 'row';
        priceContainer.style.alignItems = 'center';
        priceContainer.style.flexWrap = 'wrap';
        priceContainer.style.rowGap = '2px';
        priceContainer.style.gap = '0';
        priceContainer.style.justifyContent = 'flex-end';
        var priceRows = priceContainer.querySelectorAll('.PdpFooterContent-Price__PriceTextSmall, .PdpFooterContent-Price__PriceText');
priceRows.forEach(function(el, i) {
  el.style.display = 'flex';
  el.style.justifyContent = 'flex-end';
  el.style.alignItems = 'center';
  el.style.gap = '6px';
  if (i === 0) {
    el.style.flex = '1';
    el.style.width = 'auto';
  } else {
    el.style.width = '100%';
  }
});
setTimeout(function() {
  var host2 = document.querySelector('mw-pdp-offer');
  if (!host2 || !host2.shadowRoot) return;
  var pc = host2.shadowRoot.querySelector('.PdpFooterContent-Price__PriceContainer');
  if (!pc) return;
  var rows = pc.querySelectorAll('.PdpFooterContent-Price__PriceTextSmall, .PdpFooterContent-Price__PriceText');
  rows.forEach(function(el, i) {
    el.style.display = 'flex';
    el.style.justifyContent = 'flex-end';
    el.style.alignItems = 'center';
    el.style.gap = '6px';
    if (i === 0) {
      el.style.flex = '1';
      el.style.width = 'auto';
    } else {
      el.style.width = '100%';
    }
  });
}, 300);
        var unitTag = priceContainer.querySelector('.moov-unit-tag');

        if (IS_B2B) {
          if (unitTag) unitTag.remove();
        } else {
          if (!unitTag) {
            unitTag = document.createElement('div');
            unitTag.className = 'moov-unit-tag';
            unitTag.style.cssText = 'display:inline-flex;align-items:center;background:#F9FAFB;color:#1A1B18;font-size:13px;font-weight:700;padding:8px 16px;border-radius:8px;margin-right:8px;vertical-align:middle;box-shadow:0 6px 10px rgba(0,0,0,0.09);';
            priceContainer.insertBefore(unitTag, priceContainer.firstChild);
          }
          var price;
          if (qty >= 3) price = 'CHF 0.99 / Stick';
          else price = 'CHF 1.16 / Stick';
          unitTag.textContent = price;
        }
      }
    }

    lastQty = qty;
  }

  // ── MutationObserver auf Shadow DOM ───────────────────────
  function watchShadow() {
    var host = document.querySelector('mw-pdp-offer');
    if (!host) {
      var bodyObs = new MutationObserver(function() {
        var h = document.querySelector('mw-pdp-offer');
        if (h) {
          bodyObs.disconnect();
          waitForShadow(h);
        }
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
      return;
    }
    waitForShadow(host);
  }

  function waitForShadow(host) {
    var attempts = 0;
    var interval = setInterval(function() {
      attempts++;
      if (host.shadowRoot) {
        clearInterval(interval);
        var obs = new MutationObserver(function() {
  update();
  setTimeout(shortenProductTitles, 50);
  setTimeout(shortenProductTitles, 200);
});
        obs.observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
        update();
      }
      if (attempts > 50) clearInterval(interval);
    }, 200);
  }

  function addTrustBadges() {
    var footer = document.querySelector('.mini-cart__footer');
    if (!footer || footer.querySelector('.moov-trust')) return;

    var trust = document.createElement('div');
    trust.className = 'moov-trust';
    trust.style.cssText = 'margin:0;padding:12px 16px 0;display:flex;flex-direction:column;gap:8px;';
    trust.innerHTML = '<div style="display:flex;align-items:center;gap:8px;font-size:12px;color:#6B7280;justify-content:center;padding-top:0px;">Kein Risiko — 30 Tage Geld-zurück-Garantie</div>';

    footer.appendChild(trust);
  }

  function styleStrikePrice() {
    document.querySelectorAll('.cart-item__discounted-prices s.price, .price--on-sale s.price-item--regular').forEach(function(s) {
      if (s.dataset.replaced) return;
      s.dataset.replaced = 'true';
      var span = document.createElement('span');
      span.innerHTML = s.innerHTML;
      span.style.cssText = 'display:inline-block;position:relative;color:#9CA3AF;font-size:0.85em;';
      var line = document.createElement('span');
      line.style.cssText = 'position:absolute;left:0;right:0;top:50%;height:1px;background:#9CA3AF;transform:translateY(-50%);display:block;';
      span.appendChild(line);
      s.parentNode.replaceChild(span, s);
    });
  }

  function addDeliveryDate() {
    var footer = document.querySelector('.mini-cart__footer');
    if (!footer || footer.querySelector('.moov-delivery')) return;

    function addDeliveryDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++; // Nur Sonntag überspringen
    }
    return d;
  }
  var days = ['So.','Mo.','Di.','Mi.','Do.','Fr.','Sa.'];
  var months = ['1.','2.','3.','4.','5.','6.','7.','8.','9.','10.','11.','12.'];
  var startDate = new Date();
  var hour = startDate.getHours();
  var day = startDate.getDay();

  if (day === 6) {
    startDate.setDate(startDate.getDate() + 2); // Sa → Mo
  } else if (day === 0) {
    startDate.setDate(startDate.getDate() + 1); // So → Mo
  } else if (hour >= 16) {
    // Mo-Fr nach 16:00 → nächster Werktag
    startDate.setDate(startDate.getDate() + 1);
    if (startDate.getDay() === 6) startDate.setDate(startDate.getDate() + 2);
    if (startDate.getDay() === 0) startDate.setDate(startDate.getDate() + 1);
  }
  var from = addDeliveryDays(startDate, 1);
  var to   = addDeliveryDays(startDate, 2);
    var dateStr = days[from.getDay()] + ' ' + from.getDate() + '.' + months[from.getMonth()] +
      ' - ' + days[to.getDay()] + ' ' + to.getDate() + '.' + months[to.getMonth()];

    var el = document.createElement('div');
    el.className = 'moov-delivery';
    el.style.cssText = 'display:flex;font-size:13px;line-height:1.35;font-weight:500;color:#6aa163;padding:0 0 3px 0;';
    el.innerHTML = '<span>Lieferung ca. ' + dateStr + '</span>';

    var taxNote = footer.querySelector('.taxes-discounts');
    footer.insertBefore(el, taxNote);
  }

  function moveStarsNextToCaption() {
    var caption = document.querySelector('.product__info-container .caption-with-letter-spacing');
    var stars = document.querySelector('.product__info-container .jdgm-widget');
    if (!caption || !stars || caption.parentNode.querySelector('.moov-caption-row')) return;

    var row = document.createElement('div');
    row.className = 'moov-caption-row';
    row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;';

    caption.parentNode.insertBefore(row, caption);
    row.appendChild(caption);
    row.appendChild(stars);

    document.querySelectorAll('.product__info-container .shopify-app-block').forEach(function(block) {
      if (!block.querySelector('.jdgm-widget') && block.innerHTML.trim() === '') {
        block.style.display = 'none';
      }
    });
  }

  function updateProgressBar(qty) {
  var fill = document.getElementById('moov-progress-fill');
  var text = document.getElementById('moov-progress-text');
  if (!fill || !text) return;

  var pct, msg, left;
  var boxes = function(n){ return n + (n === 1 ? ' Box' : ' Boxen'); };

  if (qty >= 10) {
    pct = 100;
    msg = '🎉 Top! Du sparst CHF 122.- inkl. 2 Geschenken';
  } else if (qty >= 5) {
    pct = Math.max(5, ((qty - 5) / 5) * 100);
    left = 10 - qty;
    msg = 'Geschenk gesichert 🎁 Noch ' + boxes(left) + ' bis zum zweiten';
  } else if (qty >= 3) {
    pct = (qty === 4) ? 67 : Math.max(5, ((qty - 3) / 2) * 100);
    left = 5 - qty;
    msg = '15 % Rabatt aktiv! Noch ' + boxes(left) + ' bis zum Geschenk';
  } else {
    pct = Math.max(5, (qty / 3) * 100);
    left = 3 - qty;
    msg = (qty === 0) ? 'Ab 3 Boxen sparst du 15 %' : 'Noch ' + boxes(left) + ', dann sparst du 15 %';
  }

  var current = parseFloat(fill.style.width) || 0;
var target = pct;
var duration = 400;
var startTime = null;
var startVal = current;

function animateFill(timestamp) {
  if (!startTime) startTime = timestamp;
  var elapsed = timestamp - startTime;
  var progress = Math.min(elapsed / duration, 1);
  var ease = 1 - Math.pow(1 - progress, 3);
  fill.style.width = (startVal + (target - startVal) * ease) + '%';
  if (progress < 1) requestAnimationFrame(animateFill);
}
requestAnimationFrame(animateFill);
  text.textContent = msg;
}

function shortenProductTitles() {
  var host = document.querySelector('mw-pdp-offer');
  if (!host || !host.shadowRoot) return;
  host.shadowRoot.querySelectorAll('.Category-InlineProductCard__ProductTitle, .PdpFooterContent-Gift--productTitle').forEach(function(el) {
    if (el.innerHTML.includes('Elektrolyte')) {
      el.innerHTML = el.innerHTML.replace(/\s*-?\s*Elektrolyte\s*/gi, ' ');
    }
  });
}

// ── Preis pro Stick + "Du sparst" im neuen Preisbereich (mit Kaufoptionen) ──
function toNum(txt) {
  var t = (txt || '').replace(/[^\d.,]/g, '');
  if (t.indexOf(',') > -1 && t.indexOf('.') > -1) t = t.replace(/,/g, '');
  else t = t.replace(',', '.');
  return parseFloat(t);
}

function updatePriceExtra() {
  var host = document.querySelector('mw-pdp-offer');
  if (!host || !host.shadowRoot) return;
  var sr = host.shadowRoot;
  var label = sr.querySelector('.SubscriptionPurchaseOptions__TotalLabel');

  // Kein neuer Preisbereich (nur Einmalkauf) oder B2B: eigene Elemente entfernen
  if (IS_B2B || !label) {
    Array.prototype.forEach.call(sr.querySelectorAll('.moov-price-extra, .moov-tile, .moov-msg'), function(n){ n.remove(); });
    return;
  }

  // Graue Zeile "Gratisgeschenk enthalten" unter dem Preis ausblenden (grüne in der Karte bleibt)
  Array.prototype.forEach.call(sr.querySelectorAll('*'), function(el){
    if (el.children.length === 0 &&
        el.textContent.trim() === 'Gratisgeschenk enthalten' &&
        !el.closest('.mw-build-offer-purchase-option')) {
      el.style.display = 'none';
    }
  });

  function isOwn(el) {
    return el.classList && (el.classList.contains('moov-price-extra') || el.classList.contains('moov-tile') || el.classList.contains('moov-msg'));
  }

  // Kleinsten Bereich finden, der "Gesamtpreis" und den Preis enthält
  var row = label.parentElement;
  while (row && row.parentElement && !/CHF/.test(row.textContent)) row = row.parentElement;
  if (!row || !row.parentElement) return;

  // Label-Bereich und Preis-Bereich innerhalb der Zeile
  var labelBox = label;
  while (labelBox.parentElement && labelBox.parentElement !== row) labelBox = labelBox.parentElement;
  var priceBox = null;
  Array.prototype.forEach.call(row.children, function(c){
    if (!priceBox && c !== labelBox && !isOwn(c) && /CHF/.test(c.textContent)) priceBox = c;
  });
  if (!priceBox) return;

  // Preise auslesen (ohne eigene Elemente)
  var clone = row.cloneNode(true);
  Array.prototype.forEach.call(clone.querySelectorAll('.moov-price-extra, .moov-tile'), function(n){ n.remove(); });
  var re = /CHF\s*[\d'’]+(?:[.,]\d{1,2})?/g;
  var nums = (clone.textContent.match(re) || []).map(toNum).filter(function(n){ return !isNaN(n); });
  if (!nums.length) return;
  var amount = Math.min.apply(null, nums);
  var strike = Math.max.apply(null, nums);

  // Wert der Gratis-Geschenke dazurechnen
  var gifts = 0;
  var giftBox = sr.querySelector('.PdpFooterContent-FreeGifts--giftsContainer');
  if (giftBox) {
    (giftBox.textContent.match(re) || []).forEach(function(t){
      var n = toNum(t);
      if (!isNaN(n)) gifts += n;
    });
  }

  // ── Layout: links Gesamtpreis + Preis + Pillen, rechts Box-Bild ──
  row.style.display = 'grid';
  row.style.gridTemplateColumns = '1fr auto';
  row.style.columnGap = '12px';
  row.style.rowGap = '0';
  row.style.alignItems = 'start';
  row.style.justifyItems = 'start';

  labelBox.style.gridColumn = '1';
  labelBox.style.gridRow = '1';
  label.style.setProperty('font-size', '14px', 'important');
  label.style.setProperty('font-weight', '400', 'important');
  label.style.setProperty('color', '#777', 'important');
  label.style.setProperty('line-height', '1', 'important');
  label.style.paddingTop = '0';

  priceBox.style.gridColumn = '1';
  priceBox.style.gridRow = '2';
  priceBox.style.marginTop = '6px';
  priceBox.style.textAlign = 'left';

  var st = priceBox.querySelector('s, [class*="Strike"]');
  var pw = st ? st.parentElement : priceBox;
  pw.style.display = 'flex';
  pw.style.flexDirection = 'row';
  pw.style.flexWrap = 'wrap';
  pw.style.alignItems = 'baseline';
  pw.style.justifyContent = 'flex-start';
  pw.style.gap = '6px';
  Array.prototype.forEach.call(pw.children, function(c){
    c.style.setProperty('line-height', '1.1', 'important');
    c.style.margin = '0';
    if (c !== st && /CHF/.test(c.textContent)) {
      c.style.setProperty('font-size', '26px', 'important');
      c.style.setProperty('font-weight', '700', 'important');
      c.style.letterSpacing = '-0.02em';
    }
  });
  if (st) {
    st.style.setProperty('font-size', '13px', 'important');
    st.style.color = '#999';
  }

  var qty = getQty();

  // Box-Bild mit Anzahl
  var tile = row.querySelector('.moov-tile');
  if (!tile) {
    tile = document.createElement('div');
    tile.className = 'moov-tile';
    tile.style.cssText = 'grid-column:2;grid-row:1 / span 3;align-self:start;position:relative;width:58px;height:58px;border-radius:16px;background:#F3F3F1;';
    tile.innerHTML =
      '<img src="https://cdn.shopify.com/s/files/1/0985/5146/4273/files/Kundenfeedback_7.jpg?v=1792246520" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:16px;display:block;">' +
      '<span class="moov-tile-cnt" style="position:absolute;top:-8px;right:-8px;min-width:24px;height:24px;border-radius:999px;background:#1E1E1E;color:#fff;font-size:12px;font-weight:700;line-height:1;display:flex;align-items:center;justify-content:center;padding:0 6px;border:2px solid #fff;box-sizing:border-box;"></span>';
    row.appendChild(tile);
  }
  var cnt = tile.querySelector('.moov-tile-cnt');
  if (cnt.textContent !== String(qty)) cnt.textContent = String(qty);
  tile.style.display = qty > 0 ? 'block' : 'none';

  // Pillen: Preis pro Stick + Du sparst
  Array.prototype.forEach.call(sr.querySelectorAll('.moov-price-extra'), function(n){ if (n.parentElement !== row) n.remove(); });
  var box = row.querySelector('.moov-price-extra');
  if (!box) {
    box = document.createElement('div');
    box.className = 'moov-price-extra';
    box.style.cssText = 'grid-column:1;grid-row:3;display:flex;flex-wrap:wrap;align-items:center;gap:6px;margin:10px 0 0;-webkit-text-size-adjust:100%;text-size-adjust:100%;';
    var pill = 'display:inline-flex;align-items:center;font-size:12px;font-weight:600;line-height:1.2;letter-spacing:0;padding:5px 12px;border-radius:999px;white-space:nowrap;';
    box.innerHTML =
      '<span class="moov-pe-unit" style="' + pill + 'background:#F3F3F1;color:#1E1E1E;"></span>' +
      '<span class="moov-pe-save" style="' + pill + 'background:#EAF3DE;color:#3B6D11;"></span>';
    row.appendChild(box);
  }
  var saved = (strike - amount) + gifts;
  var u = (qty > 0) ? 'CHF ' + (amount / (qty * 30)).toFixed(2) + ' / Stick' : '';
  var s = (saved > 0.009) ? 'Du sparst CHF ' + saved.toFixed(2) : '';
  var unit = box.querySelector('.moov-pe-unit');
  var save = box.querySelector('.moov-pe-save');
  if (unit.textContent !== u) unit.textContent = u;
  if (save.textContent !== s) save.textContent = s;
  unit.style.display = u ? 'inline-flex' : 'none';
  save.style.display = s ? 'inline-flex' : 'none';

  // Glückwunsch-Hinweis über dem Gesamtpreis (nur wenn Abo gewählt)
  var sub = sr.querySelector('.mw-build-offer-purchase-option[data-purchase-option="subscription"]');
  var isAbo = !!sub && (sub.getAttribute('data-selected') === 'true' || sub.classList.contains('SubscriptionPurchaseOptions__PoptSelected'));
  var msg = sr.querySelector('.moov-msg');
  if (!msg) {
    msg = document.createElement('div');
    msg.className = 'moov-msg';
    msg.style.cssText = 'display:flex;align-items:center;gap:8px;border-radius:14px;padding:12px 14px;margin:0 0 16px;font-size:14px;font-weight:600;line-height:1.3;background:#EAF3DE;color:#3B6D11;-webkit-text-size-adjust:100%;text-size-adjust:100%;';
    msg.textContent = '🎉 Glückwunsch! Du erhältst den maximalen Rabatt von 25 %';
  }
  if (msg.nextElementSibling !== row) row.parentElement.insertBefore(msg, row);
  msg.style.display = (isAbo && qty >= 2) ? 'flex' : 'none';
}

function parsePrice(el) {
  if (!el) return NaN;
  var t = el.textContent.replace(/[^\d.,]/g, '').replace(',', '.');
  return parseFloat(t);
}

function updateSavings() {
  var footer = document.querySelector('.mini-cart__footer');
  if (!footer) return;

  var total = 0;
  document.querySelectorAll('.mini-cart__navigation > li').forEach(function(row) {
    var dl = row.querySelector('.cart-item__discounted-prices');
    if (!dl) return;

    var dds = dl.querySelectorAll('dd');
    if (dds.length < 2) return;

    var orig = parsePrice(dds[0]);
    var sale = parsePrice(dds[1]);
    if (isNaN(orig) || isNaN(sale) || orig <= sale) return;

    var qty = 1;
    var qi = row.querySelector('.quantity__input, input[name="updates[]"]');
    if (qi) qty = parseInt(qi.value, 10) || 1;

    total += (orig - sale) * qty;
  });

  footer.querySelectorAll('.discounts__discount').forEach(function(d) {
    var m = d.textContent.match(/\(\s*[–\-−]?\s*[A-Za-z]*\s*([\d.,]+)\s*\)/);
    if (!m) return;
    var v = parseFloat(m[1].replace(',', '.'));
    if (!isNaN(v)) total += v;
  });

  var el = footer.querySelector('.moov-savings');
  if (total <= 0) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('div');
    el.className = 'moov-savings';
    el.style.cssText = 'display:flex;font-size:13px;line-height:1.35;font-weight:500;color:#1A1B18;padding:8px 0 3px 0;';
    var anchor = footer.querySelector('.moov-delivery') || footer.querySelector('.taxes-discounts');
    if (anchor) footer.insertBefore(el, anchor);
    else footer.appendChild(el);
  }

  var txt = 'Du sparst CHF ' + total.toFixed(2);
  if (el.textContent !== txt) el.textContent = txt;
}

function addCardRabattBadge() {
  var CARDS = [
    { match:'hydrate-mix-probierpaket', type:'Einmalig', cls:'moov-card-type--once', save:'15 % sparen' },
    { match:'/products/abo',            type:'Abo',      cls:'moov-card-type--abo',  save:'25 % sparen' }
  ];

  document.querySelectorAll('.card-wrapper').forEach(function(card){
    if (card.querySelector('.moov-card-tags')) return;

    var cfg = null;
    for (var i = 0; i < CARDS.length; i++) {
      if (card.querySelector('a[href*="' + CARDS[i].match + '"]')) { cfg = CARDS[i]; break; }
    }
    if (!cfg) return;

    var title = card.querySelector('.card-information__text');
    if (!title) return;

    var row = document.createElement('div');
    row.className = 'moov-card-tags';

    var t = document.createElement('span');
    t.className = 'moov-card-type ' + cfg.cls;
    t.textContent = cfg.type;

    var b = document.createElement('span');
    b.className = 'moov-card-rabatt';
    b.textContent = cfg.save;

    row.appendChild(t);
    row.appendChild(b);
    title.parentNode.insertBefore(row, title);
  });
}


// ── Init ──────────────────────────────────────────────────
  function init() {
    initTierScroll();
    setInterval(updateSavings, 500);
    setInterval(addCardRabattBadge, 500);
    setInterval(updatePriceExtra, 400);
    watchShadow();
    setInterval(update, 400);
    setTimeout(update, 1500);
    setInterval(addTrustBadges, 500);
    styleStrikePrice();
    setInterval(addDeliveryDate, 500);
    setTimeout(moveStarsNextToCaption, 500);
    setTimeout(function() { lastQty = -1; update(); }, 2500);
    var cartObs = new MutationObserver(styleStrikePrice);
    cartObs.observe(document.body, { childList: true, subtree: true });

// Probierpaket aus Warenkorb-Empfehlungen entfernen
    var recObs = new MutationObserver(function() {
      document.querySelectorAll('a.product-title[href*="hydrate-mix-probierpaket"]').forEach(function(el) {
        var parent = el.closest('li, .card-wrapper, .grid__item, .product-card');
        if (parent) parent.remove();
        else el.remove();
      });
    });
    recObs.observe(document.body, { childList: true, subtree: true });

    // Abo aus Empfehlungen entfernen
    var aboObs = new MutationObserver(function() {
      document.querySelectorAll('a[href*="/products/abo?"][href*="pr_rec"]').forEach(function(el) {
        var parent = el.closest('li, .card-wrapper, .grid__item, .product-card');
        (parent || el).remove();
      });
    });
    aboObs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

document.querySelectorAll('a[href^="#"]').forEach(function(a) {
  a.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    var offset = target.getBoundingClientRect().top + window.pageYOffset - 80;
window.scrollTo({ top: offset, behavior: 'smooth' });
  });
});

// BixGrow Referral-Popup: Platzhalter eindeutschen
(function () {
  const fixBixgrowPlaceholders = setInterval(function () {
    const nameInput = document.getElementById('bixgrow-referral-advocate-popup-custom-page-name');
    const emailInput = document.getElementById('bixgrow-referral-advocate-popup-custom-page-email');
    if (nameInput) nameInput.placeholder = 'Dein Name (optional)';
    if (emailInput) emailInput.placeholder = 'Deine E-Mail-Adresse';
    if (nameInput && emailInput) clearInterval(fixBixgrowPlaceholders);
  }, 500);
  setTimeout(function () { clearInterval(fixBixgrowPlaceholders); }, 15000);
})();

})();







(function () {
  function styleCartHeader() {
    var title = document.querySelector('.as-shopping-cart-title');
    if (title && !title.dataset.moovDone) {
      title.textContent = 'Dein Warenkorb';
      title.dataset.moovDone = 'true';

      var sub = document.createElement('div');
      sub.textContent = 'Gute Wahl! Kostenlose A-Post Lieferung';
      sub.style.cssText = 'font-family:Poppins,sans-serif;font-size:13px;color:#5B5B5B;font-weight:400;margin-top:6px;';
      title.insertAdjacentElement('afterend', sub);
    }
  }
  var obs = new MutationObserver(styleCartHeader);
  obs.observe(document.body, { childList: true, subtree: true });
})();
